import generateCalendar from "antd/es/calendar/generateCalendar";
import { Locale } from "date-fns";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";

import { useConfigProvider } from "../ConfigProvider";
import getAntdPickerLocaleConfig from "../input/util/getAntdPickerLocaleConfig";

let component: null | ReturnType<typeof generateCalendar<Date>> = null;
let lastLocale: Locale | null = null;

const useCalendar = (): ReturnType<typeof generateCalendar<Date>> => {
  const { dateFnsLocale } = useConfigProvider();

  if (!component || lastLocale !== dateFnsLocale) {
    component = generateCalendar<Date>({
      ...dateFnsGenerateConfig,
      locale: getAntdPickerLocaleConfig(dateFnsLocale),
    });
    lastLocale = dateFnsLocale;
  }
  return component;
};

export default useCalendar;
